import type { ComponentProps } from 'react';
import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Html } from '#src/app/shared/components/html';

import { useJoinTheCommunity } from './hooks/useJoinTheCommunity';
import { HandsSvg } from './svg/Hands';

export const JoinTheCommunity: React.FC<ComponentProps<'div'>> = (props) => {
	const {
		data: { displayed, heading, text },
	} = useJoinTheCommunity();

	if (!displayed) return null;

	return (
		<div className="flex flex-col items-center justify-center gap-3" data-qa="join-the-community" {...props}>
			<HandsSvg />

			<Text variant="heading" as="h2" size="x-small">
				{heading}
			</Text>
			<Html as="div" html={text} className="max-w-96 text-lg" />
		</div>
	);
};
